import type { ThemeTokens } from '@/shared/ui/theme/tokens';
import { C } from '@/shared/ui/theme/tokens';

interface StepRowProps {
  label: string;
  done: boolean;
  loading?: boolean;
  T: ThemeTokens;
}

export function StepRow({ label, done, loading = false, T }: StepRowProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9, padding: '4px 0', transition: 'all .3s' }}>
      {done ? (
        <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke={C.primary} strokeWidth="2.5" strokeLinecap="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : loading ? (
        <div style={{ display: 'flex', gap: 4 }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="mi-anim-dot-blink"
              style={{
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: T.textMuted,
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>
      ) : (
        <div style={{ width: 13, height: 13, borderRadius: '50%', border: `2px solid ${T.border}` }} />
      )}
      <span style={{ fontSize: 11, fontWeight: done ? 600 : 500, color: done ? C.primary : T.textMuted }}>
        {label}
      </span>
    </div>
  );
}
